module.exports = __webpack_public_path__ + "static/media/dryVan.3dd9e182.svg";